import ContentLoadErrorBlock from './ContentLoadErrorBlock';
import { ContentLoadErrorBlockProps, ContentLoadErrorBlockValueProps } from './types';

export type { ContentLoadErrorBlockProps, ContentLoadErrorBlockValueProps };
export default ContentLoadErrorBlock;
